import { t } from './i18n';

type ApiErrorPayload = {
  code?: string;
};

const CODE_TRANSLATION_KEYS: Record<string, string> = {
  account_blocked: 'auth.accountBlocked',
  auth_provider_disabled: 'auth.authProviderDisabled',
  signup_disabled: 'auth.signupDisabled',
  signup_country_not_allowed: 'auth.countryNotAllowed',
  signup_country_unverified: 'auth.countryUnverified',
  platform_country_not_allowed: 'auth.platformCountryNotAllowed',
  COUNTRY_NOT_ALLOWED: 'onboarding.error.countryNotAllowed',
  PROPERTY_LIMIT_EXCEEDED: 'property.limit.error',
  DOCUMENT_STORAGE_LIMIT_EXCEEDED: 'document.storageLimitExceeded',
  ONBOARDING_CSV_INVALID: 'property.importError',
  NEW_SUBSCRIPTIONS_DISABLED: 'billing.newSubscriptionsDisabled',
  USER_SUBSCRIPTION_STARTS_BLOCKED: 'billing.userNewSubscriptionsDisabled',
  SURVEY_RATING_OUT_OF_RANGE: 'survey.public.ratingError',
  trial_expired: 'apiError.paymentRequired',
  tenant_mode_access_denied: 'apiError.forbidden',
  shared_account_read_only: 'apiError.forbidden',
  TENANT_PORTAL_LINK_NOT_AVAILABLE: 'tenantPage.portalLinkUnavailable',
  TENANT_PORTAL_INVITE_NOT_AVAILABLE: 'tenantPage.portalInviteUnavailable',
  INVALID_VAT_NUMBER: 'apiError.invalidVatNumber',
  INVALID_REQUEST: 'apiError.invalidRequest',
  INVALID_OPERATION: 'apiError.invalidOperation',
  ARGUMENT: 'apiError.argument',
  ARGUMENT_OUT_OF_RANGE: 'apiError.argumentOutOfRange',
  UNAUTHORIZED_ACCESS: 'apiError.forbidden',
  NOT_FOUND: 'apiError.notFound',
  BILLING_PROVIDER_ERROR: 'apiError.billingProvider',
};

function getStatusFallbackKey(status: number): string {
  switch (status) {
    case 400:
      return 'apiError.badRequest';
    case 401:
      return 'apiError.unauthorized';
    case 402:
      return 'apiError.paymentRequired';
    case 403:
      return 'apiError.forbidden';
    case 404:
      return 'apiError.notFound';
    case 409:
      return 'apiError.conflict';
    default:
      return 'common.errorGeneric';
  }
}

export function resolveApiErrorMessage(
  error: ApiErrorPayload | null | undefined,
  status: number,
  fallbackKey?: string,
): string {
  const code = error?.code?.trim();
  if (code && CODE_TRANSLATION_KEYS[code]) {
    return t(CODE_TRANSLATION_KEYS[code]);
  }

  return t(fallbackKey || getStatusFallbackKey(status));
}
